"use client";

import { Product } from "../../common/models/product";
import {
  formatPriceValueString,
  pricesForDisplay,
  unitDisplayLabel,
} from "./price-helpers";

export const Price = ({
  product,
  targetPriceUnit,
}: {
  product: Product;
  targetPriceUnit: string;
}) => {
  if (!product.price) {
    return <span className="text-gray-500">Price not available</span>;
  }

  const prices = pricesForDisplay(product, targetPriceUnit);
  if (!prices.length) {
    return <span className="text-sm text-gray-500">Inquire for pricing</span>;
  }

  return (
    <span>
      {prices.map((price, index) => (
        <span key={price.unit}>
          {index > 0 && <span aria-hidden="true"> · </span>}
          {formatPriceValueString({
            value: price.value,
            currency: product.price!.currency,
          })}{" "}
          per <span>{unitDisplayLabel(price.unit)}</span>
        </span>
      ))}
    </span>
  );
};

export function UnitSelect({
  options,
  onChange,
  includeEmptyOption,
  value,
}: {
  options: { value: string; label: string }[];
  onChange: (value: string) => void;
  includeEmptyOption?: boolean;
  value?: string;
}) {
  if (options.length === 0) {
    return <span className="text-gray-500">No units available</span>;
  }
  if (options.length === 1) {
    // If there's only one option, we can just return it directly
    return <span className="text-sm text-gray-700">{options[0].label}</span>;
  }
  // at the moment just a wrapper around a select element
  return (
    <select
      className="appearance-none border-none"
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
    >
      {includeEmptyOption && <option value="">Select one</option>}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
